export default __webpack_public_path__ + "static/01 - Foto Electrobiotas_SMALL-dfacae88c5f86878a52475c34d915341.png";